<img
  *ngIf="resolvedSrc"
  [src]="resolvedSrc"
  [alt]="alt"
  loading="lazy"
  (error)="onImageError()"
/>

<div class="photo-fallback" *ngIf="!resolvedSrc">
  <i *ngIf="loading" class="pi pi-spinner pi-spin"></i>
  <i *ngIf="!loading" [class]="fallbackIcon"></i>
  <span *ngIf="!loading && fallbackLabel">{{ fallbackLabel }}</span>
</div>
